<template>
	<router-view/>
</template>

<script>
export default {
	name: "Manager.vue"
}
</script>

<style scoped>

</style>
